import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getErrorHttpMessage } from "utils";
import { StoreType } from "types/genericTypes";
import { useIntl } from "react-intl";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getUsuarioPorIdHttp, getUsuariosHttp } from "actions/users";
import { setUser } from "actions/auth";
import { getEstadisticasComprasHttp, getEstadisticasUsuarioNormalHttp } from "actions/estadisticas";
import {
  cambiarEmpresaRequisicionHttp,
  cambiarProyectoRequisicionHttp,
  cancelarRequisicionHttp,
  getBitacoraRequisicionHttp,
  getJefeInmediatoHttp,
  getRequisicionPorIdHttp,
  getRequisicionPorIdSinCifrarHttp,
  getVerDetalleEstadisticaHttp,
  mandarAutorizarHttp,
  marcarAtendidaHttp,
  marcarProductoAtendidoHttp,
  procesoAutorizacionHttp,
  reportarProblemaHttp,
  surtirDisponibleHttp,
  updateRequisicionHttp,
} from "actions/requisiciones";
import { validarImagenReferencia } from "utils/validarImagen";
import { FilaInventario, normalizarFilasInventario } from "modules/inventario";
import {
  asignarInventarioExistenteOnRequiHttp,
  createInventarioOnRequiHttp,
  getInventarioHttp,
} from "actions/inventario";
import { createCotizacionHttp } from "actions/cotizacion";
import { getProveedoresHttp, getProveedoresInventarioHttp } from "actions/proveedores";
import { getTipoProductosHttp } from "actions/tipoProducto";
import { getUbicacionesHttp } from "actions/ubicacion";
import { getUnidadesMedidaHttp } from "actions/unidadMedida";
import { getCategoriasHttp } from "actions/categorias";
import { getEmpresasHttp } from "actions/empresa";
import { getProyectosHttp } from "actions/proyecto";
import env from "react-dotenv";
import type { DetalleProducto } from "modules/productoSeleccionado/types/productoSeleccionado.types";
import { crearIdLinea, faltaComentario, formatearMoneda } from "modules/productoSeleccionado";
import { useGestionCotizacion } from "modules/gestionCotizacion";

interface Proveedor {
  id_proveedor: number;
  razon_social: string;
  nombre_comercial: string;
  contacto: string;
  correo: string;
  telefono: string;
}

interface ProveedorPorProducto {
  nombre_producto?: string;
  tipo_movimiento?: number;
  proveedores: Proveedor[];
}

export const useMain = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const intl = useIntl();
  const navigate = useNavigate();

  const userName = useSelector((state: StoreType) => state?.app?.user?.data?.usuario || null);
  const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || 0);
  const idDireccionUsuario = useSelector(
    (state: StoreType) => state?.app?.user?.data?.id_direccion || 0
  );
  const privilegiosToRol: Record<string, string> = {
    "froebel.ivan": "admin",
    "torres.tannya": "daf",
    "salazar.mario": "dg",
    "hernandez.lucero": "compras",
    "delarosa.brenda": "compras",
  };

  const user = useSelector((state: StoreType) => state?.app?.user?.data);
  const nombreAutorizando = useSelector(
    (state: StoreType) => state?.app?.user?.data?.nombre || null
  );
  const apellidosAutorizando = useSelector(
    (state: StoreType) => state?.app?.user?.data?.apellidos || null
  );
  const nombreCompletoAutorizando = nombreAutorizando + " " + apellidosAutorizando;

  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [mensajeAlert, setMensajeAlert] = useState("");
  const [errorLogin, setErrorLogin] = useState(false);
  const handleisAlertOpen = () => setIsAlertOpen(true);
  const handleisAlertClose = () => setIsAlertOpen(false);

  const [isAlertOpenCrearRequisicion, setIsAlertOpenCrearRequisicion] = useState(false);
  const handleisAlertCrearRequisicionOpen = () => {
    limpiarFormularioRequisicion();
    setIsAlertOpenCrearRequisicion(true);
  };
  const handleisAlertCrearRequisicionClose = () => {
    setIsAlertOpenCrearRequisicion(false);
    limpiarFormularioRequisicion();
  };

  //ver detalles de la requisicion por tarjetas
  const [tipoQuery, setTipoQuery] = useState("");
  const [verRequisicionEstadistica, setVerRequisicionEstadistica] = useState<any>(null);
  const [isAlertOpenRequisicionEstadistica, setIsAlertOpenRequisicionEstadistica] = useState(false);
  const handleisAlertOpenRequisicionEstadistica = () => setIsAlertOpenRequisicionEstadistica(true);
  const handleisAlertCloseRequisicionEstadistica = () =>
    setIsAlertOpenRequisicionEstadistica(false);

  //Modal de ver detalles de la requisicion
  const [verDetalleRequisicion, setVerDetalleRequisicion] = useState<any>(null);
  const [isAlertOpenDetalleRequisicion, setIsAlertOpenDetalleRequisicion] = useState(false);
  const handleisAlertOpenDetalleRequisicion = () => setIsAlertOpenDetalleRequisicion(true);
  const handleisAlertCloseDetalleRequisicion = () => {
    setIsAlertOpenDetalleRequisicion(false);
  };

  const [procesando, setProcesando] = useState<boolean>(() => {
    return !!searchParams.get("id");
  });

  const [estadisticasUsuarioNormal, setEstadisticasUsuarioNormal] = useState<any>(null);
  const [estadisticasCompras, setEstadisticasCompras] = useState<any>(null);

  const [accionRequisicion, setAccionRequisicion] = useState<string>("");
  const [procesandoEnModal, setProcesandoEnModal] = useState<boolean>(false);

  // Estado para los proveedores por producto
  const [proveedoresPorProducto, setProveedoresPorProducto] = useState<
    Record<string, ProveedorPorProducto>
  >({});
  const [procesandoProveedores, setProcesandoProveedores] = useState<boolean>(false);
  const [jefeInmediato, setJefeInmediato] = useState<any>(null);

  const [tipoProductos, setTipoProductos] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [empresas, setEmpresas] = useState<any[]>([]);
  const [inventarios, setInventarios] = useState<any[]>([]);
  const [unidadesMedida, setUnidadesMedida] = useState<any[]>([]);
  const [ubicaciones, setUbicaciones] = useState<any[]>([]);
  const [almacenes, setAlmacenes] = useState<any[]>([]);
  const [productos, setProductos] = useState<any[]>([]);
  const [usuarios, setUsuarios] = useState<any[]>([]);
  //proveedores
  const [proveedores, setProveedores] = useState<any[]>([]);

  const gestion = useGestionCotizacion({
    idUsuario,
    notificar: (mensaje) => {
      setMensajeAlert(mensaje);
      handleisAlertOpen();
    },
    onCargando: setProcesando,
    proveedores,
  });

  //obtener bitacora de requisicion
  const [bitacora, setBitacora] = useState<any[]>([]);
  const [isAlertOpenBitacora, setIsAlertOpenBitacora] = useState(false);
  const handleisAlertOpenBitacora = () => setIsAlertOpenBitacora(true);
  const handleisAlertCloseBitacora = () => setIsAlertOpenBitacora(false);

  //Cotizacion por compras
  const [procesandoCotizacion, setProcesandoCotizacion] = useState<boolean>(false);
  //surtir lo disponible
  const [procesandoSurtir, setProcesandoSurtir] = useState<boolean>(false);

  /* CREAR PRODUCTO NUEVO */
  const [procesandoInventario, setProcesandoInventario] = useState<boolean>(false);
  const [isAlertOpenCrearInventario, setIsAlertOpenCrearInventario] = useState(false);
  const handleisAlertCrearInventarioOpen = () => setIsAlertOpenCrearInventario(true);
  const handleisAlertCrearInventarioClose = () => setIsAlertOpenCrearInventario(false);

  const [procesandoModal, setProcesandoModal] = useState<boolean>(false);

  const [idDetalleRequisicion, setIdDetalleRequisicion] = useState<number>(0);
  const [detalles, setDetalles] = useState<DetalleProducto[]>([]);

  /* SELECCIONAR PRODUCTO EXISTENTE */
  const [isAlertOpenListaSeleccionable, setIsAlertOpenListaSeleccionable] = useState(false);
  const handleisAlertOpenListaSeleccionable = () => setIsAlertOpenListaSeleccionable(true);
  const handleisAlertCloseListaSeleccionable = () => setIsAlertOpenListaSeleccionable(false);
  const [productoDetalle, setProductoDetalle] = useState<FilaInventario | null>(null);

  //Modal de ver detalles de la cotización
  const [datosCotizacion, setDatosCotizacion] = useState<any>(null);
  const [cotizacionLista, setCotizacionLista] = useState(false);
  const [verCotizacion, setVerCotizacion] = useState<any>(null);
  const [isAlertOpenCotizacion, setIsAlertOpenCotizacion] = useState(false);
  const handleisAlertOpenCotizacion = () => setIsAlertOpenCotizacion(true);
  const handleisAlertCloseCotizacion = () => {
    setIsAlertOpenCotizacion(false);
    setDatosCotizacion(null);
    setCotizacionLista(false);
    gestion.reiniciar();
  };
  const [procesandoProcesoAutorizacion, setProcesandoProcesoAutorizacion] =
    useState<boolean>(false);

  const [proyectos, setProyectos] = useState<any[]>([]);
  /* VISTA PREVIA DE IMAGEN DE REFERENCIA */
  const [isModalImagenOpen, setIsModalImagenOpen] = useState(false);
  const handleOpenModalImagen = () => setIsModalImagenOpen(true);
  const handleCloseModalImagen = () => setIsModalImagenOpen(false);

  //Modal de añadir producto
  const [isModalProductoOpen, setIsModalProductoOpen] = useState(false);
  const [productoSearch, setProductoSearch] = useState("");
  const [productoSeleccionado, setProductoSeleccionado] = useState<any>(null);
  const [cantidadProducto, setCantidadProducto] = useState<number | "">("");
  const [tipoMovimiento, setTipoMovimiento] = useState<number>(0);

  //subir imagen de referencia
  const [imagenReferencia, setImagenReferencia] = useState<File | null>(null);
  const [errorImagen, setErrorImagen] = useState<string | null>(null);

  /* EDITAR REQUISICIÓN */
  const [modoEdicion, setModoEdicion] = useState<boolean>(false);
  const [idRequisicionEditar, setIdRequisicionEditar] = useState<number | null>(null);
  const [imagenReferenciaActual, setImagenReferenciaActual] = useState<string | null>(null);

  //Paginación del modal de productos
  const [pageProductos, setPageProductos] = useState(0);
  const [rowsPerPageProductos, setRowsPerPageProductos] = useState(6);

  const [usuarioSearch, setUsuarioSearch] = useState("");

  //requisición individual
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const ultimaPeticionDetalle = useRef(0);

  //Boton de cotizar en el modal
  const handleCambioCotizacion = useCallback((datos: any, listo: boolean) => {
    setDatosCotizacion(datos);
    setCotizacionLista(listo);
  }, []);
  const enviarCotizacion = () => {
    if (!datosCotizacion || !cotizacionLista) return;

    crearCotizacion(datosCotizacion);
  };

  //boton atendido
  const tipoUsuarioArjion = privilegiosToRol[userName as string] ?? "";
  const proveedorCotizado = verDetalleRequisicion?.proveedores_seleccionados?.[0] ?? null;
  const esRequisicionComputo = !!verDetalleRequisicion?.id_solicitud_computo;
  const ordenesCompra: any[] = Array.isArray(verDetalleRequisicion?.ordenes_compra)
    ? verDetalleRequisicion.ordenes_compra
    : verDetalleRequisicion?.orden_compra?.id
      ? [verDetalleRequisicion.orden_compra]
      : [];
  const todasOrdenesSurtidas =
    ordenesCompra.length > 0 &&
    ordenesCompra.every((oc) => Number(oc.estatus_id) === 5);
  const puedeMarcarAtendida =
    !cargandoDetalle &&
    tipoUsuarioArjion === "compras" &&
    !!proveedorCotizado &&
    todasOrdenesSurtidas;

  const handleMarcarAtendida = () => {
    if (!verDetalleRequisicion) return;
    const detalles = ordenesCompra
      .flatMap((oc: any) => oc.detalles_orden_compra ?? [])
      .map((d: any) => ({
        id_inventario: d.id_inventario,
        cantidad: Number(d.cantidad),
        precio: Number(d.precio),
      }));

    marcarAtendida({
      id_requisicion: verDetalleRequisicion.id,
      id_usuario: idUsuario,
      detalles,
    });
  };

  const handleChangeImagen = async (newFile: File | null) => {
    setErrorImagen(null);

    if (!newFile) {
      setImagenReferencia(null);
      return;
    }

    const { error, tipo } = await validarImagenReferencia(newFile);

    if (error || !tipo) {
      setErrorImagen(error);
      setImagenReferencia(null);
      return;
    }

    const base = newFile.name.replace(/\.[^.]+$/, "");
    const extActual = newFile.name.split(".").pop()?.toLowerCase();
    const extCorrecta = tipo === "jpg" ? "jpg" : tipo;

    const archivo =
      extActual === extCorrecta || (tipo === "jpg" && extActual === "jpeg")
        ? newFile
        : new File([newFile], `${base}.${extCorrecta}`, { type: `image/${extCorrecta}` });

    setImagenReferencia(archivo);
  };

  const formikInventario = useFormik({
    initialValues: {
      clave: "",
      nombre: "",
      precio: "",
      id_unidad_medida: "",
      id_categoria: "",
      id_ubicacion: "",
      id_tipo_producto: "",
      cantidad: "",
      maximos: "",
      minimos: "",
      punto_reorden: "",
    },
    validationSchema: Yup.object({
      clave: Yup.string(),
      nombre: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      precio: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_unidad_medida: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      id_categoria: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_ubicacion: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_tipo_producto: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      cantidad: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      maximos: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      minimos: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      punto_reorden: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
    }),
    validateOnMount: true,
    onSubmit: async (values) => { },
  });

  const isFieldValidInventario = (fieldName: keyof typeof formikInventario.values) => {
    return (
      formikInventario.touched[fieldName] &&
      !formikInventario.errors[fieldName] &&
      formikInventario.values[fieldName] &&
      formikInventario.values[fieldName] !== ""
    );
  };

  const getFieldColorInventario = (fieldName: keyof typeof formikInventario.values) => {
    return isFieldValidInventario(fieldName) ? "#00AB16" : undefined;
  };

  const formik = useFormik({
    initialValues: {
      id_usuario: "",
      id_tipo_producto: "",
      id_empresa: "",
      extras: "",
    },
    validationSchema: Yup.object({
      id_usuario: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_tipo_producto: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      id_empresa: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      extras: Yup.string(),
    }),
    onSubmit: async (values) => { },
  });

  const isFieldValid = (fieldName: keyof typeof formik.values) => {
    return (
      formik.touched[fieldName] &&
      !formik.errors[fieldName] &&
      formik.values[fieldName] &&
      formik.values[fieldName] !== ""
    );
  };

  const getFieldColor = (fieldName: keyof typeof formik.values) => {
    return isFieldValid(fieldName) ? "#00AB16" : undefined;
  };

  const handleAccionRequisicion = (
    event: React.MouseEvent<HTMLElement>,
    nuevaAccionRequisicion: string
  ) => {
    setAccionRequisicion(nuevaAccionRequisicion);
  };

  const handleChangePageProductos = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageProductos(newPage);
  };

  const handleChangeRowsPerPageProductos = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPageProductos(parseInt(event.target.value, 10));
    setPageProductos(0);
  };

  const handleProductoSearchChange = (value: string) => {
    setProductoSearch(value);
    setPageProductos(0);
  };

  const handleAgregarLinea = useCallback((producto: any, cantidad: number, observaciones = "") => {
    const precio = Number(producto.precio) || 0;
    setDetalles((prev) => [
      ...prev,
      {
        id_linea: crearIdLinea(),
        id_inventario: producto.id ?? producto.id_inventario,
        nombre: producto.nombre,
        clave: producto.clave,
        tipo_producto: producto.tipo_producto?.nombre ?? producto.tipo_producto ?? "",
        precio_unitario: precio,
        cantidad,
        unidad_medida: producto.unidad_medida?.nombre ?? producto.unidad_medida ?? "",
        precio_total: precio * cantidad,
        observaciones,
      },
    ]);
  }, []);

  const handleCambiarObservacionesLinea = useCallback((idLinea: string, observaciones: string) => {
    setDetalles((prev) => prev.map((d) => (d.id_linea === idLinea ? { ...d, observaciones } : d)));
  }, []);

  const handleCambiarCantidadLinea = useCallback((idLinea: string, cantidad: number) => {
    setDetalles((prev) =>
      prev.map((d) =>
        d.id_linea === idLinea ? { ...d, cantidad, precio_total: d.precio_unitario * cantidad } : d
      )
    );
  }, []);

  const handleRemoveDetalle = useCallback((idLinea: string) => {
    setDetalles((prev) => prev.filter((d) => d.id_linea !== idLinea));
  }, []);

  const totalPedido = useMemo(
    () => detalles.reduce((sum, d) => sum + d.precio_total, 0),
    [detalles]
  );

  const getUsuarioPorId = useCallback(async (data: any) => {
    try {
      setProcesando(true);
      const response = await getUsuarioPorIdHttp(data);
      dispatch(setUser({ data: response }));
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    } finally {
      setProcesando(false);
    }
  }, []);

  const getUsuarios = useCallback(async (datos?: any) => {
    try {
      setProcesando(true);
      const usuarios = await getUsuariosHttp(datos);
      setUsuarios(usuarios);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getEstadisticasUsuarioNormal = useCallback(async (datos?: any) => {
    try {
      setProcesando(true);
      const response = await getEstadisticasUsuarioNormalHttp(datos);
      setEstadisticasUsuarioNormal(response);
      setProcesando(false);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    } finally {
      setProcesando(false);
    }
  }, []);

  const getEstadisticasCompras = useCallback(async () => {
    try {
      setProcesando(true);
      const response = await getEstadisticasComprasHttp();
      setEstadisticasCompras(response);
      setProcesando(false);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    } finally {
      setProcesando(false);
    }
  }, []);

  const getVerDetalleEstadistica = useCallback(async (datos?: any) => {
    try {
      setProcesando(true);
      const response = await getVerDetalleEstadisticaHttp(datos);
      setVerRequisicionEstadistica(response);
      setProcesando(false);
      handleisAlertOpenRequisicionEstadistica();
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    } finally {
      setProcesando(false);
    }
  }, []);

  const getRequisicionPorId = useCallback(async (data: any, silencioso = false) => {
    const peticion = ++ultimaPeticionDetalle.current;
    try {
      if (!silencioso) {
        setVerDetalleRequisicion(null);
        setCargandoDetalle(true);
      }
      const response = await getRequisicionPorIdHttp(data);
      if (response?.data?.id_creador) {
        const jefe = await getJefeInmediatoHttp({
          id_usuario_creador: response.data?.id_creador,
          id_requisicion: response.data?.id,
        } as any);
        setJefeInmediato(jefe);
      }
      if (peticion === ultimaPeticionDetalle.current) {
        setVerDetalleRequisicion(response);
      }
    } catch (error) {
      if (peticion === ultimaPeticionDetalle.current) {
        const message = getErrorHttpMessage(error);
        setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
        handleisAlertOpen();
      }
    } finally {
      if (peticion === ultimaPeticionDetalle.current) setCargandoDetalle(false);
    }
  }, []);

  const getCategorias = useCallback(async (idTipoProducto?: number) => {
    try {
      const params = idTipoProducto ? { id_tipo_producto: idTipoProducto } : {};
      const categorias = await getCategoriasHttp(params);
      setCategorias(categorias);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getProveedores = useCallback(async () => {
    try {
      setProcesando(true);
      const proveedores = await getProveedoresHttp();
      setProveedores(proveedores);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getEmpresas = useCallback(async () => {
    try {
      const empresas = await getEmpresasHttp();
      setEmpresas(empresas);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getProyectos = useCallback(async () => {
    try {
      const proyectos = await getProyectosHttp();
      setProyectos(proyectos);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getCatalogoInventario = useCallback(async () => {
    try {
      const productos = await getInventarioHttp();
      setProductos(productos);
      setInventarios(productos);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getUnidadesMedida = useCallback(async () => {
    try {
      const unidadesMedida = await getUnidadesMedidaHttp();
      setUnidadesMedida(unidadesMedida);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getUbicaciones = useCallback(async () => {
    try {
      const ubicaciones = await getUbicacionesHttp();
      setUbicaciones(ubicaciones);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getTipoProducto = useCallback(async () => {
    try {
      const tipoProductos = await getTipoProductosHttp();
      setTipoProductos(tipoProductos);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const reportarProblema = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await reportarProblemaHttp(datos);

      setMensajeAlert(intl.formatMessage({ id: "general_reportado_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_reportado_error" }));
      handleisAlertOpen();
    }
  };

  const refrescarRequisicionAbierta = async (idRequisicion?: number | string) => {
    const id = idRequisicion ?? verDetalleRequisicion?.id;
    if (!id) return;

    const actualizada: any = await getRequisicionPorIdSinCifrarHttp({
      id_requisicion: String(id),
    } as any);

    setVerDetalleRequisicion(actualizada?.data ?? actualizada);
  };

  const marcarProductoAtendido = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await marcarProductoAtendidoHttp(datos);
      // Actualiza el producto en pantalla de inmediato
      setVerDetalleRequisicion((prev: any) => {
        if (!prev) return prev;
        return {
          ...prev,
          detalles: prev.detalles.map((d: any) =>
            d.id === datos.id_producto_detalle ? { ...d, estatus: 4 } : d
          ),
        };
      });

      setMensajeAlert(intl.formatMessage({ id: "general_entregado_correctamente" }));
      handleisAlertOpen();
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_entregado_error" }));
      handleisAlertOpen();
    } finally {
      setProcesandoEnModal(false);
    }
  };

  const cambiarProyectoRequisicion = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await cambiarProyectoRequisicionHttp(datos);
      await refrescarRequisicionAbierta(datos.id_requisicion);

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      handleisAlertOpen();
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_actualizado_error" }));
      handleisAlertOpen();
    } finally {
      setProcesandoEnModal(false);
    }
  };

  const cambiarEmpresaRequisicion = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await cambiarEmpresaRequisicionHttp(datos);
      await refrescarRequisicionAbierta(datos.id_requisicion);

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      handleisAlertOpen();
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_actualizado_error" }));
      handleisAlertOpen();
    } finally {
      setProcesandoEnModal(false);
    }
  };

  const normalizarTexto = (texto: string): string =>
    texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const productosFiltradosPorTipo = useMemo(() => {
    const tipoSeleccionado = formik.values.id_tipo_producto;
    if (!tipoSeleccionado) return productos;
    return productos.filter((p: any) => String(p.id_tipo_producto) === String(tipoSeleccionado));
  }, [productos, formik.values.id_tipo_producto]);

  const productosFiltrados =
    productosFiltradosPorTipo?.filter((p: any) =>
      normalizarTexto(p.nombre).includes(normalizarTexto(productoSearch))
    ) ?? [];

  const productosPaginadosModal = useMemo(() => {
    const start = pageProductos * rowsPerPageProductos;
    return productosFiltrados.slice(start, start + rowsPerPageProductos);
  }, [productosFiltrados, pageProductos, rowsPerPageProductos]);

  const limpiarFormularioRequisicion = () => {
    formik.resetForm();
    setDetalles([]);
    setImagenReferencia(null);
    setImagenReferenciaActual(null);
    setErrorImagen(null);
    setProductoSeleccionado(null);
    setCantidadProducto("");
    setModoEdicion(false);
    setIdRequisicionEditar(null);
  };

  const handleEditarRequisicion = (requisicion: any) => {
    if (!requisicion) return;

    const detallesRequi = requisicion.detalles ?? [];

    formik.setValues({
      id_usuario: requisicion.id_usuario_solicitante ?? "",
      id_tipo_producto: detallesRequi[0]?.inventario?.id_tipo_producto ?? "",
      id_empresa: requisicion.empresa?.id ?? "",
      extras: requisicion.extras ?? "",
    });

    setDetalles(
      detallesRequi.map((d: any) => ({
        id_linea: `bd-${d.id}`,
        id_detalle: d.id,
        id_inventario: d.id_inventario,
        nombre: d.inventario?.nombre ?? "",
        clave: d.inventario?.clave ?? "",
        tipo_producto: d.inventario?.tipo_producto?.nombre ?? "",
        precio_unitario: Number(d.precio_unitario) || 0,
        cantidad: Number(d.cantidad) || 0,
        unidad_medida: d.inventario?.unidad_medida?.nombre ?? "",
        precio_total: Number(d.precio_total) || 0,
        observaciones: d.comentarios ?? "",
      }))
    );

    setImagenReferencia(null);
    setImagenReferenciaActual(requisicion.imagen_referencia || null);

    setIdRequisicionEditar(requisicion.id);
    setModoEdicion(true);

    handleisAlertCloseDetalleRequisicion();
    setIsAlertOpenCrearRequisicion(true);
  };

  const serializarDetalles = (lista: DetalleProducto[]) =>
    JSON.stringify(lista.map(({ id_linea, ...resto }) => resto));

  const getProveedoresPorProductos = useCallback(async (ids_inventario: number[]) => {
    try {
      setProcesandoProveedores(true);
      const data: any = await getProveedoresInventarioHttp(ids_inventario);
      setProveedoresPorProducto(data);
      setProcesandoProveedores(false);
    } catch (error) {
      setProcesandoProveedores(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || "Error al obtener proveedores");
      handleisAlertOpen();
    }
  }, []);

  //AUTORIZACIONES
  const enviarAutorizar = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await mandarAutorizarHttp(datos);
      setMensajeAlert(intl.formatMessage({ id: "general_enviado_autorizar_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_enviado_autorizar_error" }));
      handleisAlertOpen();
    }
  };
  const cancelarRequisicion = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await cancelarRequisicionHttp(datos);

      const actualizada: any = await getRequisicionPorIdSinCifrarHttp({
        id_requisicion: String(datos.id_requisicion),
      } as any);

      setVerDetalleRequisicion(actualizada?.data ?? actualizada);

      setMensajeAlert(intl.formatMessage({ id: "general_cancelar_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_cancelar_error" }));
      handleisAlertOpen();
    }
  };

  const marcarAtendida = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await marcarAtendidaHttp(datos);
      setMensajeAlert(intl.formatMessage({ id: "general_marcar_atendido_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_marcar_atendido_error" }));
      handleisAlertOpen();
    }
  };

  const surtirDisponible = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await surtirDisponibleHttp(datos);
      setMensajeAlert(intl.formatMessage({ id: "general_surtido_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_surtido_error" }));
      handleisAlertOpen();
    }
  };

  const createInventarioOnRequi = async (datos: any) => {
    try {
      setProcesandoModal(true);
      await createInventarioOnRequiHttp(datos);
      await refrescarRequisicionAbierta();

      setMensajeAlert(intl.formatMessage({ id: "general_añadido_correctamente" }));
      formikInventario.resetForm();
      setIdDetalleRequisicion(0);
      handleisAlertCrearInventarioClose();
      handleisAlertOpen();
      setProcesandoModal(false);
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_añadir_general" }));
      handleisAlertOpen();
    }
  };
  const actualizarProductoEnRequisicion = async (producto: FilaInventario): Promise<boolean> => {
    try {
      setProcesandoModal(true);
      const idInventario = Number(producto.registro?.id ?? producto.id);

      await asignarInventarioExistenteOnRequiHttp({
        id_inventario: idInventario,
        id_requisicion_detalle: idDetalleRequisicion,
      });

      await refrescarRequisicionAbierta();

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      setIdDetalleRequisicion(0);
      handleisAlertCloseListaSeleccionable();
      handleisAlertCrearInventarioClose();
      handleisAlertOpen();
      setProcesandoModal(false);
      return true;
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_actualizar_general" }));
      handleisAlertOpen();
      return false;
    }
  };

  const procesoAutorizacion = async (datos: any) => {
    const accion = datos.tipo_accion;
    try {
      setProcesandoEnModal(true);
      await procesoAutorizacionHttp(datos);

      await getRequisicionPorId({ id_requisicion: String(datos.id_requisicion) }, true);

      const tipo_accion =
        accion == "autorizar"
          ? intl.formatMessage({ id: "general_autorizado_correctamente" })
          : accion == "rechazar"
            ? intl.formatMessage({ id: "general_rechazado_correctamente" })
            : accion == "enviar a dg"
              ? intl.formatMessage({ id: "general_enviando_dg_correctamente" })
              : accion == "mandar a daf"
                ? intl.formatMessage({ id: "general_mandar_daf_correctamente" })
                : "";
      setMensajeAlert(tipo_accion);
      handleisAlertOpen();
      setAccionRequisicion("");
      setProcesandoEnModal(false);
    } catch (error) {
      const tipo_accion_error =
        accion == "autorizar"
          ? intl.formatMessage({ id: "general_autorizado_error" })
          : accion == "rechazar"
            ? intl.formatMessage({ id: "general_rechazado_error" })
            : accion == "enviar a dg"
              ? intl.formatMessage({ id: "general_enviando_dg_error" })
              : accion == "mandar a daf"
                ? intl.formatMessage({ id: "general_mandar_daf_error" })
                : "";
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || tipo_accion_error);
      handleisAlertOpen();
    }
  };

  const crearCotizacion = async (datos: any) => {
    try {
      setProcesandoCotizacion(true);
      await createCotizacionHttp(datos);
      await refrescarRequisicionAbierta(datos.id_requisicion);
      setMensajeAlert(intl.formatMessage({ id: "cotizacion_creada_correctamente" }));
      handleisAlertOpen();
      handleisAlertCloseCotizacion();
      setProcesandoCotizacion(false);
    } catch (error) {
      setProcesandoCotizacion(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "cotizacion_creada_error" }));
      handleisAlertOpen();
    }
  };

  const getJefeInmediato = useCallback(async (datos: any) => {
    try {
      const jefeInmediato = await getJefeInmediatoHttp(datos);
      setJefeInmediato(jefeInmediato);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  //bitacora de requisicion
  const getBitacoraRequisicionPorId = useCallback(async (datos: any) => {
    try {
      setProcesando(true);
      const response = await getBitacoraRequisicionHttp(datos);
      setBitacora(response);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const reabrirRequisicion = async (datos: any) => {
    try {
      setProcesandoModal(true);

      const formData = new FormData();
      formData.append("id_requisicion", String(datos.id_requisicion));
      formData.append("id_usuario", datos.id_usuario);
      formData.append("id_empresa", datos.id_empresa);
      formData.append("id_editor", datos.id_editor);
      formData.append("extras", datos.extras ?? "");
      if (datos.imagen_referencia) {
        formData.append("imagen_referencia", datos.imagen_referencia);
      }
      formData.append("detalles", serializarDetalles(datos.detalles));

      await updateRequisicionHttp(formData);
      //await getRequisiciones();

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      handleisAlertCrearRequisicionClose();
      handleisAlertOpen();
      setProcesandoModal(false);
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_actualizar_general" }));
      handleisAlertOpen();
    }
  };

  const filasInventario = useMemo(
    () =>
      normalizarFilasInventario(inventarios, {
        textoActivo: intl.formatMessage({ id: "general_activo" }),
        textoInactivo: intl.formatMessage({ id: "general_inactivo" }),
      }),
    [inventarios, intl]
  );

  useEffect(() => {
    const idUsuario = searchParams.get("id");

    if (!idUsuario) {
      setProcesando(false);
      return;
    }

    if (user?.id_usuario && String(user.id_usuario) === String(idUsuario)) {
      setProcesando(false);
      return;
    }

    getUsuarioPorId({ id_usuario: idUsuario });
  }, [searchParams]);

  useEffect(() => {
    const cargarCatalogosIniciales = async () => {
      setProcesando(true);
      try {
        const catalogos: Promise<any>[] = [
          getCategorias(),
          getCatalogoInventario(),
          getUnidadesMedida(),
          getUbicaciones(),
          getTipoProducto(),
          getEstadisticasCompras(),
          getEmpresas(),
          getProyectos(),
          getUsuarios({ id_direccion: idDireccionUsuario }),
          getProveedores(),
        ];

        await Promise.all(catalogos);
      } finally {
        setProcesando(false);
      }
    };

    cargarCatalogosIniciales();
  }, []);

  useEffect(() => {
    if (!idUsuario) return;
    getEstadisticasUsuarioNormal({ id_usuario: idUsuario });
  }, [idUsuario]);

  const idCotizacionActual = verCotizacion?.cotizacion?.id;
  useEffect(() => {
    if (isAlertOpenCotizacion && idCotizacionActual) {
      gestion.cargarCotizacion(idCotizacionActual);
    }
  }, [isAlertOpenCotizacion, idCotizacionActual]);

  const urlVerImagenReferencia = verDetalleRequisicion?.imagen_referencia
    ? `${env.API_URL_ASSETS}referencias_requisicion/${verDetalleRequisicion.imagen_referencia}`
    : undefined;

  const lineasSinComentario = detalles.filter(faltaComentario).length;
  const textoProductos = detalles.length > 1 ? " productos" : " producto";
  const countProductosSeleccionados = detalles.length + textoProductos;
  const totalPedidoTexto = "Total del pedido: " + formatearMoneda(totalPedido);

  const botonRequisicionDeshabilitado =
    !formik.isValid ||
    (!modoEdicion && !formik.dirty) ||
    detalles.length === 0 ||
    lineasSinComentario > 0 ||
    Boolean(errorImagen);

  return {
    intl,
    formik,
    procesando,
    isAlertOpen,
    mensajeAlert,
    getUsuarioPorId,
    handleisAlertClose,
    user,
    idUsuario,
    //cotizacion
    procesandoCotizacion,
    //autorizar
    enviarAutorizar,
    procesoAutorizacion,
    //estadisticas normales
    estadisticasUsuarioNormal,
    //estadisticas compras
    estadisticasCompras,
    //ver detalles de la requisicion
    setTipoQuery,
    tipoQuery,
    getVerDetalleEstadistica,
    verRequisicionEstadistica,
    setVerRequisicionEstadistica,
    isAlertOpenRequisicionEstadistica,
    handleisAlertOpenRequisicionEstadistica,
    handleisAlertCloseRequisicionEstadistica,
    verDetalleRequisicion,
    getRequisicionPorId,
    isAlertOpenDetalleRequisicion,
    handleisAlertOpenDetalleRequisicion,
    handleisAlertCloseDetalleRequisicion,
    //detalles cotización
    verCotizacion,
    setVerCotizacion,
    isAlertOpenCotizacion,
    handleisAlertOpenCotizacion,
    handleisAlertCloseCotizacion,
    proveedoresPorProducto,
    procesandoProveedores,
    getProveedoresPorProductos,
    crearCotizacion,
    jefeInmediato,
    getJefeInmediato,
    surtirDisponible,
    procesandoSurtir,
    marcarAtendida,
    //crear producto nuevo
    procesandoInventario,
    isAlertOpenCrearInventario,
    handleisAlertCrearInventarioOpen,
    handleisAlertCrearInventarioClose,
    formikInventario,
    getFieldColorInventario,
    unidadesMedida,
    ubicaciones,
    almacenes,
    createInventarioOnRequi,
    procesandoModal,
    setIdDetalleRequisicion,
    idDetalleRequisicion,
    //lista seleccionable de productos
    isAlertOpenListaSeleccionable,
    handleisAlertOpenListaSeleccionable,
    handleisAlertCloseListaSeleccionable,
    filasInventario,
    setProductoDetalle,
    productoDetalle,
    actualizarProductoEnRequisicion,
    categorias,
    tipoProductos,
    cancelarRequisicion,
    procesandoEnModal,
    accionRequisicion,
    handleAccionRequisicion,
    setAccionRequisicion,
    nombreCompletoAutorizando,
    procesandoProcesoAutorizacion,
    bitacora,
    isAlertOpenBitacora,
    handleisAlertOpenBitacora,
    handleisAlertCloseBitacora,
    getBitacoraRequisicionPorId,
    reportarProblema,
    //nuevos
    isModalImagenOpen,
    handleOpenModalImagen,
    handleCloseModalImagen,
    urlVerImagenReferencia,
    marcarProductoAtendido,
    proyectos,
    empresas,
    cambiarProyectoRequisicion,
    cambiarEmpresaRequisicion,
    handleEditarRequisicion,
    handleisAlertCrearRequisicionClose,
    isAlertOpenCrearRequisicion,
    detalles,
    productosFiltrados,
    botonRequisicionDeshabilitado,
    totalPedidoTexto,
    countProductosSeleccionados,
    usuarios,
    reabrirRequisicion,
    handleChangeImagen,
    imagenReferencia,
    idRequisicionEditar,
    getFieldColor,
    errorImagen,
    imagenReferenciaActual,
    handleProductoSearchChange,
    productoSearch,
    handleAgregarLinea,
    lineasSinComentario,
    handleRemoveDetalle,
    handleCambiarCantidadLinea,
    handleCambiarObservacionesLinea,
    pageProductos,
    handleChangePageProductos,
    rowsPerPageProductos,
    handleChangeRowsPerPageProductos,
    productosPaginadosModal,
    datosCotizacion,
    cotizacionLista,
    enviarCotizacion,
    handleCambioCotizacion,
    proveedores,
    cargandoDetalle,
    handleMarcarAtendida,
    puedeMarcarAtendida,
    gestion
  };
};
